import { useMutation } from '@apollo/client'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

const bulkMarkAsExported = atlas`#graphql
  mutation BulkMarkOrdersAsExported($input: BulkMarkOrdersAsExportedInput!) {
    bulkMarkOrdersAsExported(input: $input) {
      updatedOrderIds
    }
  }
`

export const useBulkMarkAsExported = () => {
  const [bulkMarkAsExportedAction] = useMutation(bulkMarkAsExported, {
    client: atlasClient,
  })
  const onBulkMarkAsExportedAction = async (
    orderIds,
    orderExportIntegrationId,
  ) => {
    const response = await bulkMarkAsExportedAction({
      variables: {
        input: {
          orderIds,
          orderExportIntegrationId,
        },
      },
    })
    return response
  }
  return onBulkMarkAsExportedAction
}

export const withBatchMarkAsExportedMutation =
  (WrappedComponent) => (props) => {
    const customProps = {
      ...props,
      handleMarkAsExported: useBulkMarkAsExported(),
    }
    return <WrappedComponent {...customProps} />
  }
